export default "__VITE_ASSET__BbjGyNHC__"